var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.videoList),function(item,index){return _c('div',{key:index,staticClass:"list-item"},[_c('video-show',{attrs:{"videoList":_vm.videoList,"selectedIndex":index,"video":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }